import { createIcon } from '@mote/ui/components/icon'

export const FormsIcon = createIcon({
  displayName: 'FormsIcon',
  path: [
    <g clipPath='url(#a)'>
      <g clipPath='url(#b)'>
        <path
          fill='#673AB7'
          d='M14.308 0H4.501C3.577 0 2.77.8 2.77 1.715v20.571c0 .914.807 1.715 1.73 1.715h15c.923 0 1.731-.8 1.731-1.715V6.857L17.192 4l-2.884-4Z'
        />
        <path
          fill='#F1F1F1'
          d='M9.693 17.715h6.923v-1.143H9.693v1.143Zm0-7.429v1.143h6.923v-1.143H9.693Zm-1.039.572a.905.905 0 0 1-.923.914c-.576 0-.922-.342-.922-.914 0-.57.346-.914.922-.914.577 0 .923.456.923.914Zm0 3.2a.905.905 0 0 1-.923.914c-.576 0-.922-.343-.922-.914s.346-.914.922-.914c.577 0 .923.457.923.914Zm0 3.085a.905.905 0 0 1-.923.914c-.576 0-.922-.342-.922-.914 0-.57.346-.913.922-.913.577 0 .923.456.923.913Zm1.039-2.285h6.923v-1.144H9.693v1.144Z'
        />
        <path fill='url(#c)' d='m14.77 6.4 6.461 6.287v-5.83l-6.462-.456Z' />
        <path
          fill='#B39DDB'
          d='M14.309 0v5.143c0 .914.807 1.714 1.73 1.714h5.193L14.309 0Z'
        />
        <path
          fill='#fff'
          fillOpacity='.2'
          d='M4.5 0c-.923 0-1.73.8-1.73 1.715v.114C2.77.914 3.577.114 4.5.114h9.808V0H4.501Z'
        />
        <path
          fill='#311B92'
          fillOpacity='.2'
          d='M19.5 23.886h-15c-.923 0-1.73-.8-1.73-1.715v.114C2.77 23.2 3.577 24 4.5 24h15c.923 0 1.731-.8 1.731-1.715v-.114c0 .915-.808 1.715-1.73 1.715Z'
        />
        <path
          fill='#311B92'
          fillOpacity='.1'
          d='M16.036 6.858c-.923 0-1.731-.8-1.731-1.715v.114c0 .914.807 1.715 1.73 1.715h5.193v-.114h-5.192Z'
        />
        <path
          fill='url(#d)'
          d='M14.308 0H4.501C3.577 0 2.77.8 2.77 1.715v20.571c0 .914.807 1.715 1.73 1.715h15c.923 0 1.731-.8 1.731-1.715V6.857L14.308 0Z'
        />
      </g>
    </g>,
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
      <clipPath id='b'>
        <path fill='#fff' d='M2.77 0h18.462v24H2.77z' />
      </clipPath>
      <radialGradient
        id='d'
        cx='0'
        cy='0'
        r='1'
        gradientTransform='matrix(238.131 0 0 235.866 3.354 .64)'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' stopOpacity='.1' />
        <stop offset='1' stopColor='#fff' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='c'
        x1='18'
        x2='18'
        y1='6.901'
        y2='12.711'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#311B92' stopOpacity='.2' />
        <stop offset='1' stopColor='#311B92' stopOpacity='.02' />
      </linearGradient>
    </defs>
  ],
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    width: '24rpx',
    height: '24rpx'
  }
})
